module.exports = __webpack_public_path__ + "img/mascot-terms.ca73cabc.svg";